




















































/** Description: 使用tag ba功能，允许选择 delivery identity的checkbox组件 */
import { defineComponent, toRefs, computed, ref } from '@vue/composition-api';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';
import { IDENTITY_TYPE_MAP } from '@tt4b/ttam-enums';

const name = 'ttam-identity-use-delivery-account';
export default defineComponent({
  name,
  components: { QuestionTooltip },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      required: true,
    },
    identityType: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { value, disabled } = toRefs(props);
    const hide = ref(false);

    const val = computed({
      get: () => value.value,
      set: v => {
        emit('change', v);
      },
    });

    const isDisabledTooltip = computed(() => !disabled.value || hide.value);

    const onHoverQuestion = () => {
      hide.value = true;
    };

    const onLeaveQuestion = () => {
      hide.value = false;
    };

    const onClick = () => {
      emit('click');
    };
    return {
      name,
      val,
      isDisabledTooltip,
      IDENTITY_TYPE_MAP,

      onClick,
      onHoverQuestion,
      onLeaveQuestion,
    };
  },
});
